var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectTemplateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    viewBox: "0 0 44 38.838",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2599",
    "data-name": "Groupe 2599",
    transform: "translate(-1388.154 -237)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2560",
    "data-name": "Groupe 2560",
    transform: "translate(-249 -295)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "T",
    transform: "translate(1634 542)",
    fill: "#ffffff",
    fontSize: 30,
    fontFamily: "Hind-Bold, Hind",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16.322,
    y: 21
  }, "T"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectTemplateIcon);
export default __webpack_public_path__ + "static/media/project-template-icon.fffc4925f5ce4abec3f3df43cd7de0ca.svg";
export { ForwardRef as ReactComponent };